export function PublicFooter() {
  const link = { color: 'var(--text-muted)', textDecoration: 'none' } as const;
  return (
    <footer style={{ maxWidth: 1160, margin: '0 auto', padding: '28px 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box' }}>
      <span style={{ fontSize: 15, fontWeight: 800, color: 'var(--text-strong)' }}>Get<span style={{ color: 'var(--brand-green)' }}>Pay</span>93</span>
      <div style={{ display: 'flex', gap: 20, fontSize: 13, fontWeight: 600 }}>
        <a href="#" style={link}>Términos</a>
        <a href="#" style={link}>Privacidad</a>
        <a href="#" style={link}>Contacto</a>
      </div>
    </footer>
  );
}
